import React, { useState } from 'react';
import './style.less';

import { Dialpad } from './DialpadComponent';
import { CallTask } from 'types/outbound';
import { Icon } from 'shared/components/Icon';
import { Popover } from 'antd';
import clsx from 'clsx';
import { Tooltip } from 'shared/components/Tooltip';
import { useAppSelector } from 'shared/store';
import { OutboundSessionStates } from 'browser/components/Outbound/OutboundSession';

export const OutboundDialpad: React.FC<{
  onDialClick: (task: CallTask) => Promise<void>;
}> = ({ onDialClick }) => {
  const { callTasks, status } = useAppSelector(state => state.outbound);
  const [open, setOpen] = useState(false);
  const callBtnDisabled = ![
    OutboundSessionStates.closed,
    OutboundSessionStates.paused,
  ].includes(status);

  return (
    <div
      className={clsx('OutboundDialpad', !callTasks?.length && 'OutboundDialpad--shadow')}
    >
      <Popover
        onVisibleChange={o => setOpen(o)}
        content={
          <Dialpad
            onDialClick={async task => {
              await onDialClick(task);
              setOpen(false);
            }}
            open={open}
            callBtnDisabled={callBtnDisabled}
          />
        }
        trigger={'click'}
        visible={open}
        overlayClassName="OutboundDialpad__popover"
        destroyTooltipOnHide
      >
        {open ? (
          <div
            className={clsx('OutboundDialpad__trigger', 'OutboundDialpad__trigger--open')}
          >
            <Icon icon={'close'} />
          </div>
        ) : (
          <Tooltip title={'Open Dialpad'} theme={'dark'}>
            <div className={clsx('OutboundDialpad__trigger')}>
              <Icon icon={'dialerFill'} />
            </div>
          </Tooltip>
        )}
      </Popover>
    </div>
  );
};
